import type { FaireProductEntity } from "../../entity_types/product";

export const p_y3n4fafhnt: FaireProductEntity = {
  token: "p_y3n4fafhnt",
  type: "product",
  name: "Sounds Like Bullshit To Me Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/36f5cf45c5ebed93b2964f372a436bd79184cffcf312093721f25fc271074cb9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/09b1ae03d39d437da42044fa87d56ed69a1cc3e3dbe97234f58ab29220e91765.jpeg",
    "https://cdn.faire.com/fastly/67e772be1827211f7a593383ab554ac2c0d75a23c78b3ffc3937b46a788b0d69.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/a5efa21b9d5cf75261c5c27059fd93afb54fa0a2ae60de34709697d03e037f29.jpeg",
    "https://cdn.faire.com/fastly/ea495d6e60aea6f1798f79535faa2e13561e3a8c5e68f851d9f8fd591ce7cdcc.jpeg"
  ],
  priceDollars: 6.75,
  description: "Can you even remember the last time someone told you something that didn't sound like complete and utter bullshit? Might as well be wearin' comfy socks while gettin lied to, amiright?\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:07.525Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
